module.exports = __webpack_public_path__ + "img/create-treatment-button-desktop-fr.563487c7.jpg";